import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Hide loader when React app mounts
const hideLoader = () => {
  const loader = document.getElementById('app-loader');
  if (loader) {
    loader.classList.add('hidden');
    setTimeout(() => {
      loader.style.display = 'none';
    }, 300);
  }
};

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Hide loader after a delay to ensure app is rendered (minimum 800ms for better UX)
setTimeout(hideLoader, 800);
